import { render, staticRenderFns } from "./FreelancerDetails.vue?vue&type=template&id=b0c80198&"
import script from "./FreelancerDetails.vue?vue&type=script&lang=js&"
export * from "./FreelancerDetails.vue?vue&type=script&lang=js&"
import style0 from "./FreelancerDetails.vue?vue&type=style&index=0&id=b0c80198&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports